import { render, staticRenderFns } from "./MultipleFormGroup.vue?vue&type=template&id=db9d415a&scoped=true"
import script from "./MultipleFormGroup.vue?vue&type=script&lang=js"
export * from "./MultipleFormGroup.vue?vue&type=script&lang=js"
import style0 from "./MultipleFormGroup.vue?vue&type=style&index=0&id=db9d415a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9d415a",
  null
  
)

export default component.exports